module.exports = __webpack_public_path__ + "img/level_up.fae91d5e.jpg";